export function mapBasicRatings({
  totalReviewCount,
  averageOverallRating,
  averageOverallStarRating,
}) {
  return {
    totalReviewCount,
    averageOverallRating,
    averageOverallStarRating,
  };
}

export function mapSubRatings(
  secondaryRatingsAveragesOrder,
  secondaryRatingsAverages,
) {
  if (
    !secondaryRatingsAverages ||
    !Array.isArray(secondaryRatingsAveragesOrder) ||
    secondaryRatingsAveragesOrder.length === 0
  ) {
    return [];
  }
  return secondaryRatingsAveragesOrder
    .filter((subRatingId) => {
      const entry = secondaryRatingsAverages[subRatingId];

      if (!entry) return false;

      const { displayType, valueRange, averageRating } = entry;

      return (
        displayType === "SLIDER" &&
        valueRange >= 2 &&
        averageRating >= 1 &&
        averageRating <= valueRange
      );
    })
    .map((subRatingId) => {
      const {
        label,
        minLabel,
        midLabel,
        maxLabel,
        averageRating,
        valueRange,
        id,
      } = secondaryRatingsAverages[subRatingId];

      return {
        id,
        label,
        minLabel,
        midLabel,
        maxLabel,
        percentage: Math.round(((averageRating - 1) / (valueRange - 1)) * 100),
      };
    });
}
